module.exports = __webpack_public_path__ + "1aa13ec8f6423867e22156c774c0e689.svg";